import React, { useState } from "react";

import KogModalSideComponent from "@/main/components/modal/ModalSide";
import { editSquareSVG } from "@/main/components/shared/icons/svg/editSquareSVG";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";

import { getTranslateByKey } from "@/main/services/utils";
import { CartPart } from "@/main/store/cart";

import * as S from "../styles";
import ModalCorrectCartPrice from "./modalCorrectCartPrice/modalCorrectCartPrice";
import { RefreshQuoteByGetItemsType } from "./types";

interface IButtonCorrectPriceProps {
	part: CartPart;
	supplierName: string;
	guidScreen: string;
	idButtonCorrectPrice: string;
	refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
}

function ButtonCorrectPrice({
	part,
	supplierName,
	guidScreen,
	idButtonCorrectPrice,
	refreshQuoteByGetItems,
}: IButtonCorrectPriceProps) {
	const [openModal, setOpenModal] = useState<boolean>(false);

	function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		e.stopPropagation();
		setOpenModal(true);
	}

	return (
		<S.ButtonCorrectPrice>
			<TooltipComponent title={getTranslateByKey("information.correctPrice")} placement="top">
				<S.IconButtonClose onClick={handleClick}>
					<span id={idButtonCorrectPrice}>{editSquareSVG()}</span>
				</S.IconButtonClose>
			</TooltipComponent>
			<KogModalSideComponent
				open={openModal}
				title={getTranslateByKey("information.editPart")}
				titleModalReducer="ModalPartEdit"
				closeModal={() => setOpenModal(false)}
			>
				{openModal && (
					<ModalCorrectCartPrice
						part={part}
						supplierName={supplierName}
						guidScreen={guidScreen}
						onCorrected={refreshQuoteByGetItems}
						closeModal={() => setOpenModal(false)}
					/>
				)}
			</KogModalSideComponent>
		</S.ButtonCorrectPrice>
	);
}

export default ButtonCorrectPrice;
